/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class OpportunityVersionVoModel extends JSONable {

  name: string | undefined = undefined;

  pipelineStage: string | undefined = undefined;

  modifiedAt: string | undefined = undefined;

  modifiedBy: string | undefined = undefined;

}
